import type {
  GeoControlPoint,
  GeoSheetSource,
  GeoSnapPoint,
} from '@entities/geodesy';
import type { SheetSnaps } from '../sheetPreview';

export const ZOOMS: ReadonlyArray<number> = [1, 1.5, 2, 3, 4];
/** Активная точка прилипания крупнее остальных во столько раз. */
export const HOT_SCALE = 1.6;
export const ACCURACY_FREE = 'по картинке — около 0,2 мм листа';

/** Куда поставлена точка: координаты листа и точка графики, к которой прилипла. */
export interface SheetPick {
  u: number;
  v: number;
  snap: GeoSnapPoint | null;
}

export interface Props {
  sheet: GeoSheetSource;
  url: string | null;
  loadError: boolean;
  snaps: SheetSnaps;
  points: GeoControlPoint[];
  selectedId: string | null;
  editable: boolean;
  /** Новая точка; возвращает её id — для строки «что поставлено». */
  onAdd: (pick: SheetPick) => string;
  onMove: (id: string, pick: SheetPick) => void;
  onSelect: (id: string) => void;
}

/** Что сказать про прилипание под листом, когда легенда значков не нужна. */
export function snapStateText(snaps: SheetSnaps, count: number, on: boolean): string | null {
  if (snaps.loading) return 'Ищем на листе точки для прилипания…';
  if (snaps.failed)
    return `Графика листа для прилипания недоступна — точка ставится ${ACCURACY_FREE}.`;
  if (count === 0)
    return `На листе не нашлось пересечений осей, свай и блоков — точка ставится ${ACCURACY_FREE}.`;
  if (!on) return `Прилипание выключено — точка ставится ${ACCURACY_FREE}.`;
  return null;
}
